import 'select2';
import 'select2/dist/css/select2';
import '../entrypoints/src/admin/jquery_plugins/dynamic_option_select2';
import LessonService from '../entrypoints/src/admin/services/lesson-service';

import { Controller } from "stimulus";
import { drop } from 'lodash';

export default class extends Controller {
  static targets = [ 'componentLesson' ];

  initialize() {
    this.bindingSelect2(this.componentLessonTarget, LessonService, 'Disciplina');
  }

  bindingSelect2($selectElement, model, itemTypeName) {
    console.log(`Binding select2 for ${itemTypeName}...`);
    console.log($selectElement.closest('turbo-frame').querySelector('.modal-dialog'));
    $($selectElement).select2()
      .dynamicOption({
        text: `+ Nova ${itemTypeName}`,
        dropdownParent: $selectElement.closest('turbo-frame').querySelector('.modal-dialog'),
        modalTitle: `Nova ${itemTypeName}`,
        modalLabelName: `${itemTypeName}`,
        saveItem: async (name, id) => {
          let resources = { lesson: { name: name } };
          let modelIdentification = !id ? await model.create(resources) : await model.update(id, resources);
          return modelIdentification.id;
        },
        removeItem: async (id) => { return await model.destroy(id) },
      });
  }
}